<div class="footer-inner">
    <div class="footer__button-wrapper">
        <app-button
                [cssClasses]="'extra-large-btn solid__blue-03'"
                [icon]="'arrow_downward'"
                [disabled]="moreButton"
                [hideLabelMobileOnly]="true"
                [ariaLabel]="('CONSENT.MORE_DETAILS' | translate) + ('GENERAL.BUTTON' | translate)"
                (buttonClicked)="onBtnClick('more')">
            {{'CONSENT.MORE_DETAILS' | translate}}
        </app-button>
    </div>
    <div class="footer__button-wrapper">
        <app-button
                [disabled]="disableSkip.length < 1"
                [cssClasses]="'extra-large-btn solid__orange-02 rotate'"
                [icon]="'arrow_upward'"
                [iconAdditionalClass]="'icon-rotate'"
                [hideLabelMobileOnly]="true"
                [ariaLabel]="('GENERAL.SKIP_TO' | translate) + ('GENERAL.BUTTON' | translate)"
                (buttonClicked)="onBtnClick('skip')">
            {{'GENERAL.SKIP_TO' | translate}}
        </app-button>
    </div>
    <div *ngIf="!disableNext" #continueInFocus class="footer__button-wrapper">
        <app-button
                cdkFocusInitial
                [tabindex]="1"
                [cssClasses]="'extra-large-btn solid__mint-07'"
                [icon]="'arrow_forward'"
                [hideLabelMobileOnly]="true"
                [ariaLabel]="('GENERAL.CONTINUE' | translate) + ('GENERAL.BUTTON' | translate)"
                (buttonClicked)="onBtnClick('next')">
            {{'GENERAL.CONTINUE' | translate}}
        </app-button>
    </div>
    <div *ngIf="disableNext" class="footer__button-wrapper">
        <app-button
                cdkFocusInitial
                [tabindex]="1"
                [cssClasses]="'extra-large-btn solid__green-03'"
                [icon]="'done'"
                [hideLabelMobileOnly]="true"
                [ariaLabel]="('GENERAL.SAVE_AND_CONTINUE' | translate) + ('GENERAL.BUTTON' | translate)"
                (buttonClicked)="onBtnClick('complete')">
            {{'GENERAL.SAVE_AND_CONTINUE' | translate }}
        </app-button>
    </div>
</div>
